// apiThirdPartyChems.ts

import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';

// Get third-party chemical mappings for a customer
export async function getThirdPartyChems(customerId: number) {
  const headersList = {
    Accept: '*/*',
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  };

  const reqOptions = {
    url: `${backendUrl}/api/customers/${customerId}/third-party-chems`,
    method: 'GET' as const,
    headers: headersList,
  };

  const { data } = await axios.request(reqOptions);
  return data;
}

// Add or update a third-party chemical mapping
export async function saveThirdPartyChem(
  customerId: number,
  chemCode: string,
  ingredientId: number,
) {
  const headersList = {
    Accept: '*/*',
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  };

  const bodyContent = JSON.stringify({
    chem_code: chemCode,
    ingredients_id: ingredientId,
  });

  const reqOptions = {
    url: `${backendUrl}/api/customers/${customerId}/third-party-chems`,
    method: 'POST' as const,
    headers: headersList,
    data: bodyContent,
  };

  const { data } = await axios.request(reqOptions);
  return data;
}


// Delete a third-party chemical mapping
export async function deleteThirdPartyChem(
  customerId: number,
  chemCode: string,
) {
  const headersList = {
    Accept: '*/*',
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json',
  };

  const reqOptions = {
    url: `${backendUrl}/api/customers/${customerId}/third-party-chems/${chemCode}`,
    method: 'DELETE' as const,
    headers: headersList,
  };

  const { data } = await axios.request(reqOptions);
  return data;
}
